export default __webpack_public_path__ + "static/media/title_l.28b27ef4.jpg";